export function getDepartmentPairs(data) {
  const departments = new Set(data?.departments || []);
  const pairs = new Map();
  for (const link of data?.interactionData || []) {
    if (
      !departments.has(link.source) ||
      !departments.has(link.target) ||
      link.source === link.target ||
      !Number.isFinite(link.meetings) ||
      link.meetings <= 0
    )
      continue;
    const names = [link.source, link.target].sort();
    const id = JSON.stringify(names);
    // Both directions describe the same meetings. Keep an actual stored direction for the drill-down key.
    if (!pairs.has(id)) pairs.set(id, { ...link, id, names });
  }
  return Array.from(pairs.values()).sort(
    (a, b) => b.meetings - a.meetings || a.id.localeCompare(b.id),
  );
}
